package ru.it_mozaika.sender.js.application.components

import mui.material.FormControl
import mui.material.FormControlProps
import mui.material.InputLabel
import mui.material.Select
import mui.system.sx
import react.FC
import react.ReactNode
import react.useMemo
import ru.it_mozaika.sender.js.application.context.useSender
import web.cssom.px

val SenderSelect = FC<FormControlProps> { props ->
    val context = useSender()
    val senders = useMemo(context.list) {
        context.list.associate { it.id to it.name }
    }
    FormControl {
        sx { minWidth = 200.px }
        fullWidth = true
        InputLabel {
            id = "sender-select-label"
            +"Отправитель:"
        }
        Select {
            labelId = "sender-select-label"
            id = "sender-select"
            value = context.currentSender.id
            label = ReactNode("Отправитель:")
            onChange = { e, _ ->
                context.setCurrentId(e.target.value)
            }

            senders.forEach { (id, title) ->
                mui.material.MenuItem {
                    value = id
                    +title
                }
            }
        }
        +props
    }
}